import React, { useEffect, useRef, useState } from 'react';
import { Globe } from 'lucide-react';

const GoogleTranslate = () => {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    if (open) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [open]);

  useEffect(() => {
    // Elimina cualquier elemento duplicado con id google_translate_element
    document.querySelectorAll('#google_translate_element').forEach((el, idx) => {
      if (idx > 0) el.remove();
    });
    // Carga el script solo si no existe
    if (!window.googleTranslateElementInit) {
      window.googleTranslateElementInit = function () {
        new window.google.translate.TranslateElement({
          pageLanguage: 'es',
          includedLanguages: 'en,es,pt,fr,de,it,ja,ko,zh',
          layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
          autoDisplay: false
        }, 'google_translate_element');
      };
      const script = document.createElement('script');
      script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <div ref={containerRef} className="relative">
      <button
        className="flex items-center justify-center p-2 rounded-full hover:bg-gray-100 transition"
        aria-label="Seleccionar idioma"
        onClick={() => setOpen((v) => !v)}
        type="button"
      >
        <Globe size={22} className="text-gray-700" />
      </button>
      {open && (
        <div className="absolute right-0 mt-2 bg-white rounded shadow-lg border p-2 z-50 min-w-[160px]">
          <div id="google_translate_element" />
        </div>
      )}
    </div>
  );
};

export default GoogleTranslate;
